import { AxiosResponse } from 'axios';

import { request } from '@cvt/clients/baseClient';
import { snakizeObject } from '@cvt/helpers/object';

import { mapUserData } from './authClient.formatter';


const authApiBaseUrl = import.meta.env.VITE__CVT_API_URL;

const signupWithEmailAndPassword = (data: Auth.SignupWithEmailAndPassword) => {
  return request({
    authenticate: false,
    options: {
      url: `${authApiBaseUrl}/signup/`,
      method: 'POST',
      data: snakizeObject<Auth.SignupWithEmailAndPasswordApi>(data),
    },
  });
};

const signupWithSSO = (invitationToken?: string) => {
  return request({
    options: {
      url: `${authApiBaseUrl}/signup-with-sso/`,
      method: 'POST',
      data: {
        user_invitation_id: invitationToken,
      },
    },
  });
};

const getMe = (): Promise<AxiosResponse<Users.User>> => {
  return request({
    options: {
      url: `${authApiBaseUrl}/me/`,
      method: 'GET',
    },
  }).then((data: AxiosResponse<Users.UserApi>) => ({
    ...data,
    data: mapUserData(data.data),
  }));
};

// Both link emails are rendered and sent by our backend rather than Firebase,
// so they carry the 4i template and sending domain. Firebase only mints the
// link. The endpoints always answer 204 — never treat a resolved promise as
// proof the address has an account.
const sendPasswordResetLink = (email: string, turnstileToken: string) => {
  return request({
    authenticate: false,
    options: {
      headers: { 'CF-Turnstile-Token': turnstileToken },
      url: `${authApiBaseUrl}/reset-password/`,
      method: 'POST',
      data: { email },
    },
  });
};

const sendHubSignInLink = (email: string, turnstileToken: string) => {
  return request({
    authenticate: false,
    options: {
      headers: { 'CF-Turnstile-Token': turnstileToken },
      url: `${authApiBaseUrl}/hub/sign-in-link/`,
      method: 'POST',
      data: { email },
    },
  });
};

export const authClient = {
  signupWithEmailAndPassword,
  signupWithSSO,
  getMe,
  sendPasswordResetLink,
  sendHubSignInLink,
};
